import KanbanBoard from './KanbanBoard';

export default function DashboardPage() {
  return <KanbanBoard />;
}
